<template>
  <div
    class="card"
    @mouseover="mouseover"
    @mouseleave="mouseleave"
    :class="{ active: active, select: select }"
  >
    <slot></slot>
    <div class="view-drag" v-if="select">
      <a-icon type="drag" />
    </div>
    <div class="view-action" v-if="select">
      <a-icon type="copy" />
      <a-icon type="delete" />
      <!-- <CopyOutlined />
        <DeleteOutlined /> -->
    </div>
  </div>
</template>

<script>
// import {CopyOutlined, DeleteOutlined} from '@ant-design/icons-vue';
export default {
  name: "HmCard",
  components: {
    // CopyOutlined,
    // DeleteOutlined
  },
  props: {
    select: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    mouseover() {
      this.active = true;
    },
    mouseleave() {
      this.active = false;
    },
  },
};
</script>
<style scoped>
.card {
  position: relative;
  margin: 5px;
  padding-bottom: 18px;
  min-height: 30px;
  width: calc(100% - 10px);
  background: rgb(249, 252, 255);
  /* border:1px dashed black; */
  border: 1px dashed hsla(0, 0%, 66.7%, 0.7);
}
.active {
  outline: 1px solid #409eff;
  background: rgb(237, 245, 255);
}
.select {
  outline: 2px solid #409eff;
  border: 1px solid #409eff;
}
.view-action {
  position: absolute;
  right: 0px;
  bottom: 0px;
  height: 24px;
  line-height: 28px;
  background: #409eff;
  z-index: 9;
}
.view-drag {
  position: absolute;
  left: -2px;
  top: -2px;
  bottom: -18px;
  height: 24px;
  line-height: 24px;
  background: #409eff;
  z-index: 9;
}
.anticon {
  font-size: 14px;
  color: #fff;
  margin: 0 5px;
  cursor: pointer;
}
</style>
